import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="0 0 48 48" fill="none"><path fill="#8141EB" fill-rule="evenodd" d="M16.797 19.422C12.72 17.515 4.353 12.432 3.482 7.363c-1.117 4.466.2 10.369 3.21 13.287 2.735 2.652 2.93 4.132 2.93 5.276l-.102-.016c-.567-.086-1.717-.26-2.66-1.436 0 2.596 3.662 10.005 8.15 12.283-.447-.707-.977-2.373-.67-3.769 1.89.996 4.83 2.736 6.84 7.649.152-1.515.156-3.071-.608-4.637H20v-.964c-.481-.682-1.132-1.366-2.003-2.048-4.103-3.21-3.992-10.244-1.2-13.566ZM28 20.492V27h-8v3.777a6.516 6.516 0 0 1 8-10.285ZM27.336 36c-.765 1.566-.76 3.122-.608 4.637.393-.962.822-1.801 1.272-2.538V36h-.664Zm13.132-9H37v-8h-5.022c4.289-2.162 11.635-6.905 12.448-11.637 1.116 4.466-.2 10.369-3.21 13.287-2.736 2.652-2.931 4.132-2.931 5.276l.038-.006.064-.01c.568-.086 1.717-.26 2.661-1.436 0 .616-.206 1.502-.58 2.526Z" clip-rule="evenodd"></path><path fill="#E5EBEF" fill-rule="evenodd" d="M43 34h-8v8h-5v-8h-8v-5h8v-8h5v8h8v5Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
